export default __webpack_public_path__ + "static/media/bg_leafTint_4_rb.04dc731a.png";